import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'index',
    },
  },
  {
    name: 'user',
    path: '/user',
    component: () => import('./view/user'),
    meta: {
      title: '会员中心',
    },
  },
  {
    name: 'order',
    path: '/order',
    component: () => import('./view/order'),
    meta: {
      title: '订单管理',
    },
  },
  {
    name: 'index',
    path: '/index',
    component: () => import('./view/goods'),
    meta: {
      title: '充值管理',
    },
  },
  {
    name: 'huafei',
    path: '/huafei',
    component: () => import('./view/goods/huafei'),
    meta: {
      title: '话费充值',
    },
  },
  {
    name: 'openlist',
    path: '/openlist',
    component: () => import('./view/list/openlist'),
    meta: {
      title: '开卡记录',
    },
  },
  {
    name: 'uselist',
    path: '/uselist',
    component: () => import('./view/list/uselist'),
    meta: {
      title: '用卡记录',
    },
  },
  {
    name: 'oauth',
    path: '/public/oauth',
    component: () => import('./view/public/oauth'),
    meta: {
      title: '',
    },
  },
  // {
  //   path:'/404',
  //   meta: { title: "", tabbar: false, auth: false },
  //   component:()=>import("./view/public/404")
  // },
  // {
  //   path:'/error',
  //   meta: { title: "", tabbar: false, auth: false },
  //   component:()=>import("./view/public/error")
  // },


];

const router = createRouter({
  routes,
  history: createWebHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
